import { useReducer } from 'react';
import { logmarData } from '../data';

const initialState = {
  logmarSize: logmarData[0],
  finalScore: 1,
};

const logmarReducer = (existingData, action) => {
  const { logmarSize, finalScore } = existingData;
  const currentLogmarIndex = logmarData.findIndex((logmarObj) => logmarObj.id === logmarSize.id);

  switch (action.type) {
    case 'setInitialLogmarSize':
      return { ...existingData, logmarSize: action.payload, finalScore: (action.payload.value * 10 + 1) * 0.1 };
    case 'decrementLogmarSize':
      return { ...existingData, logmarSize: logmarData[currentLogmarIndex + 1] };
    case 'incrementLogmarSize':
      const newLogmar = logmarData[currentLogmarIndex - 1];
      return { ...existingData, logmarSize: newLogmar, finalScore: (newLogmar.value * 10 + 1) * 0.1 };
    case 'adjustFinalScore':
      return { ...existingData, finalScore: finalScore - action.payload };
    default:
      return existingData;
  }
};

export const useLogmarData = () => {
  const [currentLogmarData, updateLogmarData] = useReducer(logmarReducer, initialState);
  return { currentLogmarData, updateLogmarData };
};
